import React from 'react';
import PanelSection from '../FormElements/PanelSection';

export default class UserHistory extends React.Component {
	constructor(props) {
		super(props);

		const data = this.props.data || [];

		this.state = {
			data: data,
			loading: data && data.length ? false : true
		};

		this.loadData = this.loadData.bind(this);
	}

	componentDidMount() {
		if (!this.state.data || this.state.data.length === 0) {
			this.loadData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.endpoint !== this.props.endpoint) {
			this.loadData();
		}
	}

	render() {
		// console.log(this.props)

		let section = null;
		if (this.state.data) {
			console.log(this.state.data);
			section = (
				<div className="UserHistory">
					<PanelSection title={I18n.t('admin.user.history-title')}>
						{this.state.data.map((d) => (
							<div key={d.activity} className="activity-container">
								<div className="activity-name">{d.activity}</div>
								<div className="activity-date">{d.date}</div>
							</div>
						))}
					</PanelSection>
				</div>
			);
		}

		return (
			<div>
				{this.state.loading ? (
					<div className="loadingOverlay">
						<div className="spinner" />
					</div>
				) : null}
				<div>{section}</div>
			</div>
		);
	}

	loadData() {
		this.setState({ loading: true });
		$.ajax({
			type: 'POST',
			url: this.props.endpoint
		}).done((data) => {
			//console.log('UserGeneral loadData done', data);
			this.setState({ data: data, loading: false });
		});
	}
}
